module.exports = __webpack_public_path__ + "media/Splash.21faafea.mp3";